import type { Site, SiteApi } from '@/types/Site';
import { resolveDownloadSvg } from '@/utils/resolveBackendUrl';

export class SiteMapper {
    private static siteProperties: Array<keyof SiteApi> = [
        'id',
        'name',
        'url',
        'urlCGV',
        'shopUrl',
        'languageList',
        'features',
        'translationUrl',
        'baseTexture',
        'configurationUrl',
        'sceneBackgroundColor',
        'screenshotBackgroundColor',
        'primaryColor',
        'secondaryColor',
        'exportPSD',
        'shouldShowUploadLogoModal',
        'logo',
        'logoMobile',
        'options'
    ];

    static getSiteFromData(siteData: SiteApi): Site {
        SiteMapper.checkSiteData(siteData);
        const {
            id,
            name,
            url,
            urlCGV,
            shopUrl,
            languageList,
            features,
            baseTexture,
            translationUrl,
            configurationUrl,
            sceneBackgroundColor,
            screenshotBackgroundColor,
            primaryColor,
            secondaryColor,
            exportPSD,
            shouldShowUploadLogoModal,
            logo,
            logoMobile,
            options,
            isSupportEnabled
        } = siteData;

        const site: Site = {
            id: id || '',
            name: name || '',
            siteUrl: url || '',
            tosUrl: urlCGV || '',
            shopUrl: shopUrl || '',
            languageList: languageList || [],
            features: features || [],
            baseTextureUrl: baseTexture || '',
            translationUrl: translationUrl || '',
            configurationUrl: configurationUrl || '',
            sceneBackgroundColor: sceneBackgroundColor || '',
            screenshotBackgroundColor: screenshotBackgroundColor || '',
            primaryColor: primaryColor || '',
            secondaryColor: secondaryColor || '',
            exportMode: exportPSD || false,
            shouldShowUploadLogoModal: shouldShowUploadLogoModal || false,
            logoDesktopUrl: resolveDownloadSvg(logo) || '',
            logoMobileUrl: resolveDownloadSvg(logoMobile) || '',
            options: options || [],
            isSupportEnabled: isSupportEnabled ?? false
        };

        return site;
    }

    private static checkSiteData(siteData: SiteApi): void {
        SiteMapper.siteProperties.forEach((property) => {
            if (siteData[property] == null) {
                console.error(`Property ${property} is missing or undefined in this site: ${siteData.id}.`);
            }
        });
    }
}
